/**
 * https://de.wikipedia.org/wiki/Service_Worker:
 *Service Worker bezeichnet eine moderne Browsertechnologie, die mittels JavaScript einen Proxy zwischen dem Webbrowser und dem Server bereitstellt, der vielfältig genutzt werden kann. Der bekannteste Einsatzzweck ist es, bestimmte Seiten auch offline verfügbar zu machen. Daneben bieten Service Worker auch die Grundlage für Push-Benachrichtigungen, progressive Web-Apps und weitere Verwendungen.
 *
 * der Service Worker zunächst über die JavaScript-Funktion navigator.serviceWorker.registert
 * --> registerServiceWorker() --> dabei wird ihm der pfad zu dem javascript public/sw.js zugewiesen
 *
 * initialiseServiceWorker() --> check if push-messages supported and enabled for in current browser
 *  if everything is as reqierd  subscription = registration.pushManager --> updateSubscription(subscription)
 *
 * updateSubscription(subscription) stores subscription.key .auth .endpoint via route /api/v1/subscriptions
 *
 *  subscribe() uses the Voluntary Application Server Identification (VAPID):
 *  subscription = registration.pushManager.subscribe(vapidPublicKey) and updates to backend
 *  updateSubscription(subscription)
 *
 *       NotificationEvent to serviceWorker --> notificationPush(event) -->sendNotification(event)-->
 *       registration.showNotification(data.title, data)
 *
 */

import axios from "axios";
/**
 * Register the service worker.
 */
export function registerServiceWorker() {
  if (!("serviceWorker" in navigator)) {
    console.log("Service workers aren't supported in this browser.");
    return;
  }

  navigator.serviceWorker
    .register("/sw.js")
    .then(() => initialiseServiceWorker());
}

export function initialiseServiceWorker() {
  if (!("showNotification" in ServiceWorkerRegistration.prototype)) {
    console.log("Notifications aren't supported.");
    return;
  }

  if (Notification.permission === "denied") {
    console.log("The user has blocked notifications.");
    return;
  }

  if (!("PushManager" in window)) {
    console.log("Push messaging isn't supported.");
    return;
  }

  navigator.serviceWorker.ready.then(registration => {
    registration.pushManager
      .getSubscription()
      .then(subscription => {
        if (!subscription) {
          return;
        }

        updateSubscription(subscription);
      })
      .catch(e => {
        console.log("Error during getSubscription()", e);
      });
  });
}

export function updateSubscription(subscription) {
  const key = subscription.getKey("p256dh");
  const token = subscription.getKey("auth");

  const data = {
    endpoint: subscription.endpoint,
    key: key
      ? btoa(String.fromCharCode.apply(null, new Uint8Array(key)))
      : null,
    token: token
      ? btoa(String.fromCharCode.apply(null, new Uint8Array(token)))
      : null
  };

  axios.post("/api/v1/subscriptions", data).then(() => {
    return false;
  });
}

/**
 * Send a request to the server to delete user's subscription.
 *
 * @param {PushSubscription} subscription
 */

export function deleteSubscription(subscription) {
  axios
    .post("/api/v1/subscriptions/delete", {
      endpoint: subscription.endpoint
    })
    .then(() => {
      return false;
    });
}

/**
 * Subscribe for push notifications.
 */
export function subscribe() {
  navigator.serviceWorker.ready.then(registration => {
    const options = { userVisibleOnly: true };
    const vapidPublicKey = window.Laravel.vapidPublicKey;

    if (vapidPublicKey) {
      options.applicationServerKey = urlBase64ToUint8Array(vapidPublicKey);
    }

    registration.pushManager
      .subscribe(options)
      .then(subscription => {
        updateSubscription(subscription);
      })
      .catch(e => {
        if (Notification.permission === "denied") {
          console.log("Permission for Notifications was denied");
        } else {
          console.log("Unable to subscribe to push.", e);
        }
      });
  });
}

/**
 * https://github.com/Minishlink/physbook/blob/02a0d5d7ca0d5d2cc6d308a3a9b81244c63b3f14/app/Resources/public/js/app.js#L177
 *
 * @param  {String} base64String
 * @return {Uint8Array}
 */
export function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - (base64String.length % 4)) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");

  const rawData = window.atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }

  return outputArray;
}

export function unsubscribe() {
  navigator.serviceWorker.ready.then(registration => {
    registration.pushManager
      .getSubscription()
      .then(subscription => {
        if (!subscription) {
          return;
        }
        subscription
          .unsubscribe()
          .then(() => {
            deleteSubscription(subscription);
          })
          .catch(e => {
            console.log("Unsubscription error: ", e);
          });
      })
      .catch(e => {
        console.log("Error thrown while unsubscribing.", e);
      });
  });
}
